import { UploadIcon } from '@panwds/icons';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useIntl } from 'react-intl';
import { v4 as uuidV4 } from 'uuid';
import { Button } from '../Button/index.js';
import { Subtitle } from '../Typography/index.js';
export function FileUpload({ onFiles, multiple = true, disabled = false, acceptFiles, className, dataTestId, dataMetrics, title, dragActiveText, dragAreaText, buttonLabel, separatorLabel, children }) {
    const intl = useIntl();
    title =
        title ??
            intl.formatMessage({
                defaultMessage: 'File Upload',
                id: 'CZnN//',
                description: 'The default title for the File Upload'
            });
    dragActiveText =
        dragActiveText ??
            intl.formatMessage({
                defaultMessage: 'Drop file here to upload',
                id: 'FUmPnF',
                description: 'A label indicating where to drop files to upload'
            });
    buttonLabel =
        buttonLabel ??
            intl.formatMessage({
                defaultMessage: 'Browse File',
                id: 'QmkMlT',
                description: 'A button to pick and choose files'
            });
    separatorLabel =
        separatorLabel ??
            intl.formatMessage({
                defaultMessage: 'or',
                id: 'mlsLjA',
                description: 'A label indicating an alternative action'
            });
    const onDrop = useCallback((acceptedFiles) => {
        const mappedFiles = acceptedFiles.map((file) => {
            return {
                id: uuidV4(),
                file,
                progress: 0,
                progressType: 'pending',
                errorMessage: ''
            };
        });
        onFiles(mappedFiles);
    }, []);
    const fileValidator = (file) => {
        if (acceptFiles && !acceptFiles?.split(',').includes(`.${file.name?.split('.')?.pop()}` ?? '')) {
            return {
                code: 'file-type-not-allowed',
                message: `Only ${acceptFiles} types are allowed`
            };
        }
        return null;
    };
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple,
        disabled,
        validator: fileValidator
    });
    const oneFile = intl.formatMessage({
        defaultMessage: 'Drag and drop one file here',
        id: 'q0kbh6',
        description: 'A label indicating where to drag and drop a file'
    });
    const multipleFiles = intl.formatMessage({
        defaultMessage: 'Drag and drop one or more files here',
        id: 'ngJP7p',
        description: 'A label indicating where to drag and drop several files'
    });
    return (React.createElement("div", null,
        title && (React.createElement(Subtitle, { size: "lg", addClassName: "tw-space-x-1 tw-block tw-mb-1 tw-text-xs tw-leading-5 tw-font-lato tw-font-bold" }, title)),
        React.createElement("div", { ...getRootProps(), "data-testid": dataTestId || 'file-upload', "data-metrics": dataMetrics, className: className },
            React.createElement("input", { ...getInputProps(), "data-testid": "dropzone", id: "uploadLabel" }),
            isDragActive ? (React.createElement("div", { className: "tw-flex tw-p-4 tw-border-dashed tw-border tw-h-24 tw-border-gray-400 dark:tw-border-gray-800 tw-justify-center tw-items-center tw-bg-gray-100 tw-gap-1 tw-rounded tw-flex-col" },
                React.createElement(Subtitle, { size: "lg", addClassName: "tw-text-center tw-text-xs tw-font-normal tw-text-secondary tw-font-lato tw-p-0 tw-m-0" }, dragActiveText))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `tw-flex tw-p-4 tw-border-dashed tw-border tw-h-24
            ${disabled
                        ? 'tw-bg-gray-100/[.40] dark:tw-bg-gray-1000/[.40] tw-cursor-not-allowed tw-border-gray-400/[.40] dark:tw-border-gray-800/[.40]'
                        : 'tw-border-gray-400 dark:tw-border-gray-800 tw-bg-white hover:tw-bg-gray-100 dark:hover:tw-bg-gray-1000 dark:tw-bg-gray-1050'}
              tw-justify-center tw-items-center tw-gap-2 tw-rounded tw-flex-col` },
                    React.createElement(Subtitle, { size: "lg", addClassName: `tw-text-center tw-text-xs tw-font-normal ${disabled
                            ? 'tw-text-secondary/[.40] dark:tw-text-gray-300/[.40]'
                            : 'tw-text-secondary dark:tw-text-gray-300'} tw-font-lato tw-p-0 tw-m-0` }, dragAreaText || (!multiple ? oneFile : multipleFiles)),
                    React.createElement(Subtitle, { size: "lg", addClassName: `tw-text-center tw-text-xs ${disabled
                            ? 'tw-text-secondary/[.40] dark:tw-text-gray-300/[.40]'
                            : 'tw-text-secondary dark:tw-text-gray-300'} tw-font-lato tw-p-0 tw-m-0` }, separatorLabel),
                    React.createElement(Button, { size: "sm", fullWidth: false, disabled: disabled, icon: React.createElement(UploadIcon, { size: "sm" }), appearance: "secondary" }, buttonLabel))))),
        children));
}
//# sourceMappingURL=FileUpload.js.map